<ng-template>
  <div class="ant-select-dropdown ant-select-dropdown--single ant-select-dropdown-placement-bottomLeft"
    #panel
    [@.disabled]="noAnimation?.nzNoAnimation"
    [nzNoAnimation]="noAnimation?.nzNoAnimation"
    [@slideMotion]="dropDownPosition"
    [class.ant-select-dropdown-hidden]="!showPanel"
    [ngClass]="nzOverlayClassName"
    [ngStyle]="nzOverlayStyle">
    <div style="overflow: auto;">
      <ul class="ant-select-dropdown-menu  ant-select-dropdown-menu-root ant-select-dropdown-menu-vertical"
        role="menu"
        aria-activedescendant>
        <ng-template *ngTemplateOutlet="nzDataSource ? optionsTemplate : contentTemplate"></ng-template>
      </ul>
    </div>
  </div>
  <ng-template #contentTemplate>
    <ng-content></ng-content>
  </ng-template>
  <ng-template #optionsTemplate>
    <nz-auto-option *ngFor="let option of nzDataSource" [nzValue]="option">{{option}}</nz-auto-option>
  </ng-template>
</ng-template>